"use client";
import { fadeUp, stagger } from "@/app/lib/utils/motionVariants";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/app/ui/accordion";
import { motion } from "framer-motion";

type FaqProps = {
    data: unknown;
};
export default function FaqPage(data: any) {
    if (!data) {
        return null;
    }
    const items = data.data.faqs;
    const title = data.data.title ?? "";
    const highlight = data.data.titleHighlight?.trim();
    const highlightIndex = highlight
        ? title.toLowerCase().indexOf(highlight.toLowerCase())
        : -1;

    // const items = [
    //     { "q": "Can I switch plans anytime?", "a": "Yes, you can upgrade or downgrade your plan at any time. Changes take effect from the next billing cycle." },
    //     { "q": "Is there a free trial?", "a": "Yes, we offer a 14-day free trial on all plans. No credit card required." },
    //     { "q": "What payment methods do you accept?", "a": "We accept all major credit/debit cards, UPI, net banking, and bank transfers." }
    // ];
    return (
        <>
            <section className="relative min-lg:h-[50vh] flex flex-col items-center justify-center">
                <div className="-translate-x-1/2 -z-1 absolute aspect-square left-1/2 max-w-full lg:max-w-[2560px] md:aspect-auto md:min-h-[500px] pointer-events-none top-0 w-full">
                    <div className='shadow-[0_0_120px_110px_rgb(36,91,187),0_0_220px_218px_rgb(36,91,187),0_0_790px_320px_rgb(36,91,187)] h-[0.1px] w-[0.1px] left-1/3 top-1/4 -translate-middle absolute rounded-full backdrop-blur-xl bg-[rgb(22,154,156)] scale-150 opacity-40'></div>
                    <div className="absolute -bottom-40 left-0 w-full md:w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
                    <div className="absolute -bottom-40 right-0 w-full md:w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full lg:w-[800px] h-[800px] bg-accent/10 rounded-full blur-3xl" />
                </div>
                <div className="container mx-auto relative z-10 pt-24 lg:pt-32 pb-4 md:pb-6 lg:pb-8">
                    <motion.div initial="hidden" animate="visible" variants={stagger} className="max-w-4xl mx-auto text-center">
                        <motion.h1 variants={fadeUp} className="banner-title">
                            {highlightIndex >= 0 && highlight ? (
                                <>
                                    {title.slice(0, highlightIndex)}
                                    <span className="banner-highlight-title">
                                        {title.slice(highlightIndex, highlightIndex + highlight.length)}
                                    </span>
                                    {title.slice(highlightIndex + highlight.length)}
                                </>
                            ) : (
                                title
                            )}
                        </motion.h1>
                        <motion.p variants={fadeUp} className="mt-3 banner-description">{data.data.description}</motion.p>
                    </motion.div>
                </div>
            </section>

            <section className="relative py-6 lg:py-8">
                <div aria-hidden className="absolute inset-0 star-field pointer-events-none" />
                <div className="container mx-auto max-w-4xl relative z-10">
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
                        <Accordion type="single" collapsible className="space-y-3">
                            {items.map((item: any, i: number) => (
                                <motion.div key={i} variants={fadeUp}>
                                    <AccordionItem
                                        value={`item-${i}`}
                                        className="group rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-md shadow-[0_4px_24px_-12px_rgba(0,0,0,0.4)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/[0.06] hover:border-white/20 hover:shadow-[0_8px_32px_-12px_hsl(var(--primary)/0.25)] data-[state=open]:bg-white/[0.07] data-[state=open]:border-white/25 px-5"
                                    >
                                        <AccordionTrigger className="hover:no-underline text-left font-semibold py-3.5 leading-normal ">{item.question}</AccordionTrigger>
                                        {/* <AccordionContent className="text-muted-foreground leading-relaxed pb-5 -translate-y-1" 
                                        dangerouslySetInnerHTML={{ __html: item.answer }} /> */}
                                        <AccordionContent className="text-muted-foreground leading-relaxed pb-5 -translate-y-1">
                                            <div
                                                className="post-content mx-auto max-w-4xl "
                                                dangerouslySetInnerHTML={{ __html: item.answer }}
                                            />
                                        </AccordionContent>
                                    </AccordionItem>
                                </motion.div>
                            ))}
                        </Accordion>
                    </motion.div>
                </div>
            </section>
        </>
    );
}
